import { ethers } from "ethers";

export function convertAndOperate(
  decimalValue: number | string,
  rateInWei: string | bigint,
  operation: "divide" | "multiply",
  decimals: number = 18,
): number {
  /**
   * Convert the decimal value into wei, perform the operation with rateInWei,
   * and convert the result back to a decimal value using ethers.js
   */

  // Convert decimal value to wei using parseUnits
  // Handle values starting with "." by prepending a "0"
  let formattedValue: string;
  if (typeof decimalValue === "number") {
    formattedValue = decimalValue.toFixed(decimals);
  } else {
    formattedValue = decimalValue.toString();
    // If the value starts with a decimal point, prepend a zero
    if (formattedValue.startsWith(".")) {
      formattedValue = "0" + formattedValue;
    }
  }

  const valueInWei = ethers.parseUnits(formattedValue, decimals);

  // Convert rateInWei to a proper BigInt if it's a string
  const rateBigInt = ethers.toBigInt(rateInWei);

  let resultInWei: bigint;

  if (operation === "divide") {
    // For division, we need to multiply by an extra 10^decimals to maintain precision
    const scaleFactor = ethers.parseUnits("1.0", decimals);
    // (valueInWei * scale) / rateBigInt
    resultInWei = (valueInWei * scaleFactor) / rateBigInt;
  } else if (operation === "multiply") {
    // For multiplication, we need to divide by 10^decimals to get back to the right scale
    resultInWei =
      (valueInWei * rateBigInt) / ethers.parseUnits("1.0", decimals);
  } else {
    throw new Error("Invalid operation. Use 'divide' or 'multiply'.");
  }

  // Convert back to decimal using formatUnits
  return Number(ethers.formatUnits(resultInWei, decimals));
}
